import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.userTablesFieldsDefinition, paths.systemTablesFieldsDefinition],
        config: {
            headerName: getLocalizedString("fieldCode"),
            field: "code",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.userTablesFieldsDefinition, paths.systemTablesFieldsDefinition],
        config: {
            headerName: getLocalizedString("fieldNameAlt"),
            field: "name",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.userTablesFieldsDefinition, paths.systemTablesFieldsDefinition],
        config: {
            headerName: getLocalizedString("fieldType"),
            field: "typeString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.userTablesFieldsDefinition, paths.systemTablesFieldsDefinition],
        config: {
            headerName: getLocalizedString("size"),
            field: "size",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.userTablesFieldsDefinition, paths.systemTablesFieldsDefinition],
        config: {
            headerName: getLocalizedString("incomeType"),
            field: "requiredString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.userTablesFieldsDefinition, paths.systemTablesFieldsDefinition],
        config: {
            headerName: getLocalizedString("fieldComment"),
            field: "comment",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.userTablesFieldsDefinition, paths.systemTablesFieldsDefinition],
        config: {
            headerName: getLocalizedString("visualComponentForEditor"),
            field: "componentString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.userTablesFieldsDefinition, paths.systemTablesFieldsDefinition],
        config: {
            headerName: getLocalizedString("order"),
            field: "order",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.userTablesFieldsDefinition, paths.systemTablesFieldsDefinition],
        config: {
            headerName: getLocalizedString("keyField"),
            field: "keyFieldString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.userTablesFieldsDefinition, paths.systemTablesFieldsDefinition],
        config: {
            headerName: getLocalizedString("hidden"),
            field: "hiddenString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.userTablesFieldsDefinition, paths.systemTablesFieldsDefinition],
        config: {
            headerName: getLocalizedString("protected"),
            field: "disabledString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.userTablesFieldsDefinition, paths.systemTablesFieldsDefinition],
        config: {
            headerName: getLocalizedString("gridColumnType"),
            field: "columnTypeInGridString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.userTablesFieldsDefinition, paths.systemTablesFieldsDefinition],
        config: {
            headerName: getLocalizedString("Tooltip"),
            field: "tooltip",
            filter: "agTextColumnFilter",
        }
    },
]